export enum Separator {
  Both = 'both',
  Bottom = 'bottom',
  Top = 'top',
}
